function Services() {
    return (
      <>
  
{/* Header Start */}
<div className="container-fluid bg-breadcrumb1">
<div className="bg-breadcrumb-single" />
<div className="container text-center py-5" style={{ maxWidth: 900 }}>
  <h4
    className="text-white display-4 mb-4 wow fadeInDown"
    data-wow-delay="0.1s"
  >
    Services
  </h4>
  <p style={{ fontSize: "30px", color: "white", fontWeight: "bold" }}>
  Innovative, Reliable, Scalable
</p>
 
</div>
</div>
<br />

<div className="container-fluid service py-3">
    <div className="container py-2">
        <div className="text-center mx-auto pb-3 wow fadeInUp" data-wow-delay="0.1s" style={{ maxWidth: 800 }}>
            {/* <h2 className="text-primary">SERVICES WE PROVIDE</h2> */}
        </div>
        <div className="row pb-4 g-3 justify-content-center text-center">
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/infrastructure1.jpg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/infrastructure" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> Infrastructure
                                <br /> Solutions
                            </a>
                            <p className="mb-4">
                                Empower your business with robust, scalable, and secure infrastructure solutions designed to support today’s digital...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/infrastructure">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/businessanalytics.jpg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/business" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> Business
                                <br />Analytics
                            </a>
                            <p className="mb-4">
                                Unlock powerful insights and drive smarter decision-making with our Business Analytics solutions. We specialize ...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/business">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.5s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/saperp.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/erp" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> SAP & ERP
                                <br />Solutions
                            </a>
                            <p className="mb-4">
                                Streamline, innovate, and scale your business operations with our expert SAP services. Our team specializes in both SAP and Oracle...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/erp">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>


            {/*
            <div className="col-12">
                <a className="btn btn-primary rounded-pill py-3 px-5 wow fadeInUp" data-wow-delay="0.1s" href="/">
                  Services More
                </a>
            </div> */}
        </div>
        <div className="row g-3 justify-content-center text-center">
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.7s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/cybersecurity.jpg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/cyber" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> Cyber
                                <br />Security
                            </a>
                            <p className="mb-4">
                                In today’s digital landscape, robust cybersecurity is essential for safeguarding sensitive data and ensuring business...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/cyber">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/microserv.jpeg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/micro" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> Micro
                                <br />Services
                            </a>
                            <p className="mb-4">
                                Microservices architecture is transforming how applications are built, scaled, and managed. By breaking down...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/micro">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-6 col-lg-4 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                <div className="service-item bg-light rounded">
                    <div className="service-img">
                        <img src="assets/img/itstaff.jpg" className="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    <div className="service-content text-center p-4">
                        <div className="service-content-inner">
                            <a href="/It" className="h4 mb-2 d-inline-flex text-start">
                                <i className="fas fa-donate fa-2x me-2" /> IT
                                <br />Staffing
                            </a>
                            <p className="mb-4">
                                Our IT recruitment services connect you with top talent, handpicked to drive your business forward. In today’s...
                            </p>
                            <a className="btn btn-light rounded-pill py-2 px-4" href="/It">
                        Read More
                      </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
        {/* <section className="feature section-padding" id="service">
        <div className="container">
          <div className="row text-center">
            <div
              className="section-title wow zoomIn"
              style={{ visibility: "visible", animationName: "zoomIn" }}
            >

              <p></p>
            </div>
            <div style={{ marginBottom: 20 }} className="col-md-12 col-sm-4 col-xs-12">
              <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInLeft"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "visible",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "fadeInLeft"
                  }}
                >
                  <h4>Infrastructure Solutions</h4>
                  <p>
                    Empower your business with robust, scalable, and secure
                    infrastructure solutions designed to support...
                  </p>
                  <a href="/infrastructure">Read More</a>
                </div>
              </div> */}
              {/*- END COL */}
              {/* <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInDown"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "visible",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "fadeInDown"
                  }}
                > */}
                  {/* <h4>Business Analytics</h4>
                  <p>
                    Unlock powerful insights and drive smarter decision-making with
                    our Business Analytics solutions...
                  </p>
                  <a href="/business">Read More</a>
                </div>
              </div> */}
              {/*- END COL */}
              {/* <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInRight"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "visible",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "fadeInRight"
                  }}
                > */}
                  {/* <h4>ERP Solutions</h4>
                  <p>
                  Streamline, innovate, and scale your business operations with our expert SAP services...
                  </p>
                  <a href="erp">Read More</a>
                </div>
              </div>
            </div>
            <div style={{ marginBottom: 20 }} className="col-md-12 col-sm-4 col-xs-12">
            <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInRight"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "hidden",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "none"
                  }}
                >
                  <h4>Cyber Security</h4>
                  <p>
                    In today's digital landscape, robust cybersecurity is essential
                    for safeguarding sensitive data...
                  </p>
                  <a href="cyber">Read More</a>
                </div>
              </div>
              <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInRight"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "visible",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "fadeInRight"
                  }}
                > */}
                  {/* <h4>Micro Services</h4>
                  <p>
                    OIn today's digital landscape, seamless communication between
                    applications is essential...
                  </p>
                  <a href="micro">Read More</a>
                </div>
              </div> */}
              {/* <div className="col-md-4 col-sm-4 col-xs-12">
                <div
                  className="about_single wow fadeInRight"
                  data-wow-delay="0.1s"
                  data-wow-duration="1s"
                  data-wow-offset={0}
                  style={{
                    visibility: "hidden",
                    animationDuration: "1s",
                    animationDelay: "0.1s",
                    animationName: "none"
                  }}
                >
                  <h4>IT Staffing</h4>
                  <p>
                    Finding the right talent to drive your IT projects forward is
                    essential. Our specialized technology...
                  </p>
                  <a href="it">Read More</a> */}
                {/* </div> */}
              {/* </div> */}
              {/*- END COL */}
              {/*- END COL */}
            {/* </div> */}
            {/* </div> */}
            {/*- END COL */}
            
          {/*- END CONTAINER */}
         {/* </div> */}
       {/* </section> */}

        {/* Footer */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>USA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> 1500 S Dairy Ashford Rd <br /> Ste 355 Houston, TX 77077</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><em><span style={{ fontSize: 20 }}><strong>CANADA</strong></span></em></p>
              <p><i className="fas fa-map-marker me-1" /> 998 Loft Court, London, Ontario, N6G0J9</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p><span style={{ fontSize: 20 }}><em><strong>INDIA</strong></em></span></p>
              <p><i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor, Arjun Plaza, SP Road, Nizampet, Hyderabad, Telangana - 500085</p>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com"><i className="fas fa-envelope me-2" /> info@celersoft.com</a>
                <a href="tel:+18322258898"><i className="fas fa-phone me-2" /> (+1) 832-225-8898</a>
                <hr />
                <div className="d-flex align-items-center">
                  <a className="btn btn-light btn-md-square me-2" href="https://www.facebook.com/celersoft">
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a className="btn btn-light btn-md-square me-0" href="https://www.linkedin.com/company/celersoft/">
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
       <div className="container-fluid copyright py-3">
          <div className="container">
            <div className="row g-4 align-items-center">
              <div className="col-md-6 text-center text-md-start mb-md-0">
                <span className="text-body">
                  <i className="fas fa-copyright text-light me-1" />
                  2024 Celersoft. All rights reserved.
                </span>
              </div>
              {/* <div className="col-md-6 text-center text-md-end text-body">
              <a
                    className="border-bottom text-primary"
                    href="https://htmlcodex.com"
                >
                    HTML Codex
                </a>{" "}
                Distributed By{" "}
                <a
                    className="border-bottom text-primary"
                    href="https://themewagon.com"
                >
                    ThemeWagon
                </a>


              </div> */}
            </div>
          </div>
        </div>
       {/* <a href="/Services" className="btn btn-primary btn-lg-square back-to-top">
          <i className="fa fa-arrow-up" />
        </a> */}

<button
  className="btn btn-primary btn-lg-square back-to-top"
  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
>
  <i className="fa fa-arrow-up" />
</button>

  
      </>
    );
};

export default Services